import { z } from 'zod';

export const NotifyContentScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','publishedAt','expiredAt','deactivatedAt','lastNotifiedAt','scheduledAt','headline','tagline','body','isDraft','channels','authorId','voiceBody','voiceForceSendAll','voiceAudioResourceId']);

export default NotifyContentScalarFieldEnumSchema;
